import { useLocation, matchPath } from 'react-router-dom';
import { PATH } from '../router/PATH';
import { getNavigationBackTarget } from './navigation';
import { isAuthenticated } from '../utils';

const canNavigateBack = () => {
    if (typeof globalThis.window === 'undefined') {
        return false;
    }

    const historyState = globalThis.window.history.state as
        { idx?: number } | null | undefined;

    return typeof historyState?.idx === 'number' && historyState.idx > 0;
};

export const useLayout = () => {
    const location = useLocation();

    // The seller POS is a full-screen kiosk with its own top bar, so — like the
    // auth screens (enrollment + seller-select) — it opts out of the AppShell.
    // The admin app (dashboard, transactions, …) renders inside the shell; only
    // a BranchAdmin reaches those routes, so the shell is admin-only in effect.
    const shouldWrapWithLayout =
        location.pathname !== PATH.ENROLL &&
        location.pathname !== PATH.LOGIN &&
        location.pathname !== PATH.SELLER;

    // Pages with a fixed back target (see getNavigationBackTarget)
    // always offer the back button, even when opened directly with no
    // in-app history to pop.
    const showBack =
        getNavigationBackTarget(location.pathname) !== null ||
        canNavigateBack();

    return {
        showBack,
        shouldWrapWithLayout,
    };
};
